import React, { useEffect, useState } from 'react';
import './tooltip.css';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({PopupID="", setIsEdit, setEditId}) {
    const store_data = JSON.parse(store());
    const [NoticeBoard, setNoticeBoard] = useState([]);
    
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchNoticeBoard = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/notice-board/list", filter);
        if (response?.status == 1) {
            setNoticeBoard(response?.data);
        } else {
            setNoticeBoard([]);
        }
        console.log(response)
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                setCanExport(true);
                fetchNoticeBoard();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "NoticeBoards", "VIEW");
                const createAllowed = await hasPermission("SETTINGS", "NoticeBoards", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "NoticeBoards", "EDIT");
                const deleteAllowed = await hasPermission("SETTINGS", "NoticeBoards", "DELETE");
                const toggleAllowed = await hasPermission("SETTINGS", "NoticeBoards", "TOGGLESTATUS");
                const exportAllowed = await hasPermission("SETTINGS", "NoticeBoards", "EXPORT");
                
                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                setCanExport(exportAllowed);
                
                if (viewAllowed) {
                    fetchNoticeBoard();
                }
            }
        };
        checkPermissions();
    }, [])

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/notice-board/toggle-status", filter);
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/notice-board/remove", filter);
        if (response?.status == 1) {
            toast.success('Additional charges removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    return (
        <>
            <ToastContainer />
            <table className="table card-table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th style={{width: '100px'}}>Status</th>
                        <th style={{width: '160px'}}>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="5" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : NoticeBoard && NoticeBoard.length > 0 ?
                            NoticeBoard.map((val, index) => (
                                <tr key={index + 1}>
                                    <td>{val?.notice_title}</td>
                                    <td>{val?.notice_content}</td>
                                    <td>{val?.notice_date}</td>
                                    <td>
                                        <span className="tooltip">
                                            <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>
                                                {val?.status === 1 ? 'Active' : 'Inactive'}
                                            </span>
                                            <span className="tooltiptext">Change Status</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="tooltip">
                                            <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}><i className="fa fa-pen"></i></span>
                                            <span className="tooltiptext">Edit Notice Board</span>
                                        </span>
                                        <span className="tooltip">
                                            <span className="badge bg-label-danger me-1 cursor-pointer"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            ><i className="fa fa-trash"></i></span>
                                            <span className="tooltiptext">Delete Notice Board</span>
                                        </span>
                                    </td>
                                </tr>
                            ))
                            : ""
                    }
                </tbody>
            </table>
        </>
    )
}
